export const GHL_PASSWORD_REQUIREMENTS_MESSAGE =
  "Password must be more than 12 characters and include uppercase, lowercase, numbers, and special characters";

export function validateGhlPassword(password) {
  const value = String(password || "");
  if (!value) {
    return "AI 24/7 Password is required.";
  }
  if (value.length <= 12) {
    return GHL_PASSWORD_REQUIREMENTS_MESSAGE;
  }
  if (!/[A-Z]/.test(value)) {
    return GHL_PASSWORD_REQUIREMENTS_MESSAGE;
  }
  if (!/[a-z]/.test(value)) {
    return GHL_PASSWORD_REQUIREMENTS_MESSAGE;
  }
  if (!/[0-9]/.test(value)) {
    return GHL_PASSWORD_REQUIREMENTS_MESSAGE;
  }
  if (!/[^A-Za-z0-9]/.test(value)) {
    return GHL_PASSWORD_REQUIREMENTS_MESSAGE;
  }
  return null;
}
